/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/fail-mark-otg': {
    width: 110,
    height: 110,
    viewBox: '0 0 110 110',
    data: '<rect pid="0" x="1" y="1" width="108" height="108" rx="54" _fill="#C90025"/><path pid="1" _fill="#fff" d="M42.332 52h26.337v6H42.332z"/><rect pid="2" x="1" y="1" width="108" height="108" rx="54" _stroke="#fff" stroke-width="2"/>'
  }
})
